module.exports = "/shifts/modal-shift-view-18cb85.html";